import { useFlag } from '../FeatureFlag/FeatureFlag'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

export const useGiftCardEnabled = () => {
  const { restaurantInfo } = useRestaurant()
  const flagOn = useFlag('oo-v3-gift-card-redemption')
  const { loading, data, error } = restaurantInfo
  if (loading || error) return false
  const { restaurant } = data
  const {
    giftCardConfig: { redemptionAllowed }
  } = restaurant
  return Boolean(flagOn && redemptionAllowed)
}
